(() => {
  let updating = false;

  const bundleEntries = (value) =>
    String(value || '')
      .split(';;')
      .map((entry) => entry.trim())
      .filter(Boolean)
      .map((entry) => {
        const splitAt = entry.lastIndexOf('|');
        return [entry.slice(0, splitAt), Number(entry.slice(splitAt + 1)) || 0];
      });

  const updateBundle = async (line, quantity) => {
    if (updating) return;
    const entries = bundleEntries(line.dataset.fdoBundleQuantities);
    const parentKey = line.dataset.lineItemKey;
    const parent = entries.find(([key]) => key === parentKey);
    const previous = parent ? parent[1] : 1;
    const updates = {};
    entries.forEach(([key, current]) => {
      updates[key] = previous > 0 ? Math.round((current * quantity) / previous) : 0;
    });
    updating = true;
    document.dispatchEvent(new CustomEvent('shapes:cart:lock'));
    const sections = typeof getCartSectionRequestIds === 'function' ? getCartSectionRequestIds() : [];
    let data = null;
    try {
      const response = await fetch(window.theme.routes.cart_update_url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify({
          updates,
          sections: sections.join(','),
          sections_url: window.location.pathname,
        }),
      });
      data = await response.json();
    } catch (error) {
      data = { status: 422, message: error?.message || 'Could not update the journal.' };
    }
    updating = false;
    document.dispatchEvent(new CustomEvent('shapes:cart:unlock'));
    if (!data || data.status) return;
    window.dispatchEvent(
      new CustomEvent('shapes:cart:cartqtychange', {
        bubbles: true,
        detail: {
          response: data,
          key: parentKey,
          quantity,
          previousQuantity: previous,
          variantId: null,
          originalTarget: line,
        },
      })
    );
  };

  document.addEventListener(
    'click',
    (event) => {
      const remove = event.target.closest('[data-fdo-bundle-remove]');
      if (!remove) return;
      const line = remove.closest('[data-fdo-bundle-quantities]');
      if (!line) return;
      event.preventDefault();
      event.stopPropagation();
      updateBundle(line, 0);
    },
    true
  );

  document.addEventListener(
    'change',
    (event) => {
      const input = event.target;
      if (!(input instanceof HTMLInputElement) || !input.name.startsWith('updates[')) return;
      const line = input.closest('[data-fdo-bundle-quantities]');
      if (!line) return;
      event.preventDefault();
      event.stopPropagation();
      updateBundle(line, Math.max(0, Number(input.value) || 0));
    },
    true
  );
})();
